export default __webpack_public_path__ + "static/media/Ficha_frijol_EN.7350ea81.png";